
import Card from "../UI/Card";
import SignUpForm from "./SignUpForm";


const SignUp = () => {
  return (
    <Card className="form-card">
      <SignUpForm />
    </Card>
  );
};

export default SignUp;
